export default __webpack_public_path__ + "static/media/completed.8f509c8b.png";